import { Link, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const BranchSetting = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [settingItem, setSettingItem] = useState([]);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    description: "",
    keyName: "",
    settingItems: [],
    branchId: branchId,
  });


  const getGridData = async () => {
    const resp = await apiMethod.getBranchSettings(filterModel.branchId, filterModel.title, filterModel.size, filterModel.part);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
      setSettingItem(resp.data.settingItems)
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.description = "";
    formModel.keyName = "";
    formModel.settingItems = [];
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getBranchSettingInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.description = resp.data.description;
    formModel.keyName = resp.data.keyName;
    formModel.settingItems = resp.data.settingItems;
    formModel.branchId = resp.data.branchId;

    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async (e) => {
    if (!validForm())
      return false;

    setLoading(true);
    const resp = await apiMethod.createBranchSetting(formModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
      
    await getGridData();
    setShowFormModal(false);
    setLoading(false);
    return true;
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/#5`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#5`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                تنظیمات پایه شعبه
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>
                تنظیمات پایه شعبه
                <a href={`/sale/${branchId}/softwareGuide/#section1`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-1 col-lg-4'></div>
                  <div className='col-12 col-md-5 col-lg-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => {
                          refactorSetting()
                        }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>بازنشانی تنظیمات اولیه</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive'>
                <table className="table table-striped" >
                  <thead>
                    <tr className='text-center'>
                      <th width="20px">ردیف</th>
                      <th>عنوان</th>
                      <th>مقدارها</th>
                      <th>توضیحات</th>
                      <th width="50px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gridData.map((setting, index) => (
                      <tr key={setting.id}>
                        <td>{((filterModel.part - 1) * filterModel.size) + index + 1}</td>
                        <td>{setting.title}</td>
                        <td>
                          {setting.settingItems ? (
                            <ul className='my-auto'>
                              {JSON.parse(setting.settingItems).map((item, index) => (
                                <li key={index}>
                                  <span>{item.Title}:</span> {item.SettingValue}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>{setting.description}</td>
                        <td>
                          <button
                            onClick={() => editItem(setting.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);

  };

  const refactorModal = () => {
    setShowDeleteModal(true);
  };

  const refactorSetting = async () => {
    setLoading(true);
    const resp1 = await apiMethod.refactorBranchSetting(filterModel.branchId);
    setLoading(false);
    if (methods.showApiErrors(resp1)) {
      getGridData();
      setShowDeleteModal(false);
      resetForm();
    }
  };

  const Modal = () => {
    const modalTitle = `ویرایش ${formModel.title}`;
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">{modalTitle}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                {formModel.settingItems && JSON.parse(formModel.settingItems).map((item, index) => (
                  <div key={index} className="col-md-12">
                    {item.DataType === 8 ? (
                      <>
                        <input type="checkbox" id={`settingValue-${index}`} name={`settingValue-${index}`}
                          checked={Boolean(item.SettingValue)}
                          onChange={(e) => {
                            const newSettingItems = JSON.parse(formModel.settingItems);
                            newSettingItems[index].SettingValue = e.target.checked;
                            setFormModel(prevData => ({
                              ...prevData,
                              settingItems: JSON.stringify(newSettingItems)
                            }));
                          }}
                        />
                        <label htmlFor={`settingValue-${index}`} className="form-label ms-2">{item.Title}</label>
                      </>
                    ) : (
                      <>
                        <label htmlFor={`settingValue-${index}`} className="form-label ms-2">{item.Title}</label>
                        <input type="text" className="form-control" id={`settingValue-${index}`} name={`settingValue-${index}`}
                          value={item.Title !== "settingValue" ? item.SettingValue : formModel.settingItems[index].SettingValue}
                          readOnly={item.Title === "settingValue"}
                          onChange={(e) => {
                            const newSettingItems = JSON.parse(formModel.settingItems);
                            newSettingItems[index].SettingValue = e.target.value;
                            setFormModel(prevData => ({
                              ...prevData,
                              settingItems: JSON.stringify(newSettingItems)
                            }));
                          }}
                        />
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-50"
                onClick={() => { createNewItem() }}
              >ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  const renderResetModal = () => {
    return (
      <div className="modal fade show " tabIndex="-1" role="dialog" style={{ display: showDeleteModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">بازنشانی تنظیمات اولیه</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeDeleteModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <p className='text-center py-3 '>از انجام عملیات اطمینان دارید؟</p>
            </div>
            <div className="modal-footer text-center">
              <button
                type="button"
                className="btn custome-btn w-25 "
                onClick={closeDeleteModal}
              >
                خیر
              </button>
              <button
                type="button"
                className="btn custome-btn btn-danger w-25 "
                onClick={() => { refactorSetting() }}>بله </button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal && renderResetModal()}
    </>
  );
}

export default BranchSetting;